import { render, staticRenderFns } from "./hotel.vue?vue&type=template&id=7b31f5ce&"
import script from "./hotel.vue?vue&type=script&lang=ts&"
export * from "./hotel.vue?vue&type=script&lang=ts&"
import style0 from "./hotel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports